import { Component } from '@angular/core';

/** The app logo */
@Component({
  selector: 'io-provetech-logo',
  templateUrl: '../../assets/logo.svg',
  styles: []
})
export class LogoSvg {}
